import { render, staticRenderFns } from "./AssessmentSummary.vue?vue&type=template&id=96f42dee"
import script from "./AssessmentSummary.vue?vue&type=script&lang=js"
export * from "./AssessmentSummary.vue?vue&type=script&lang=js"
import style0 from "./AssessmentSummary.vue?vue&type=style&index=0&id=96f42dee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports